export const MATRIX_DEV_USERS = {
  test: {
    userId: "@test:ruschinawiki.duckdns.org",
    accessToken: "syt_dGVzdA_TVjoGnPlJANkuMwFYdHy_43ZWiX",
  },

  manager: {
    userId: "@manager:ruschinawiki.duckdns.org",
    accessToken: "syt_bWFuYWdlcg_aWqLDxMcIXBnqRAKDvLa_0ZdaGp",
  },

  pantecs: {
    userId: "@pantecs:ruschinawiki.duckdns.org",
    accessToken: "syt_cGFudGVjcw_SvuTESliNxgJsmViMtiR_126U82",
  },
};

export const MATRIX_HOMESERVER =
  "https://ruschinawiki.duckdns.org";